import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface MeteorologyAgroWBSequentialMapsState {
  periodStart: string | undefined;
  periodEnd: string | undefined;
  variable: string | undefined;
}

const initialState: MeteorologyAgroWBSequentialMapsState = {
  periodStart: undefined,
  periodEnd: undefined,
  variable: undefined,
};

export const meteorologyAgroWBSequentialMapsSlice = createSlice({
  name: 'meteorologyAgroWBSequentialMaps',
  initialState,
  reducers: {
    setPeriodStart: (state, action: PayloadAction<string | undefined>) => {
      state.periodStart = action.payload;
    },
    setPeriodEnd: (state, action: PayloadAction<string | undefined>) => {
      state.periodEnd = action.payload;
    },
    setVariable: (state, action: PayloadAction<string | undefined>) => {
      state.variable = action.payload;
    },
  },
});

export const selectMeteorologyAgroWBSequentialMapsPeriodStart = (state: any) => (
  state.meteorologyAgroWBSequentialMaps.periodStart
);
export const selectMeteorologyAgroWBSequentialMapsPeriodEnd = (state: any) => (
  state.meteorologyAgroWBSequentialMaps.periodEnd
);
export const selectMeteorologyAgroWBSequentialMapsVariable = (state: any) => (
  state.meteorologyAgroWBSequentialMaps.variable
);

export const {
  setPeriodStart,
  setPeriodEnd,
  setVariable,
} = meteorologyAgroWBSequentialMapsSlice.actions;

export default meteorologyAgroWBSequentialMapsSlice.reducer;
